// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
// import FixBody from '../js_vendor/FixBody.js';
import Fader from '../js_vendor/Fader.js';
import FoldOut from '../js_vendor/FoldOut.js';
import AnimateIt from '../js_vendor/AnimateIt.js';
// import Switcher from '../js_vendor/Switcher.js';
import * as Vars from './0-vars.js';
import * as Listeners from './1-listeners.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';

// exported variables ---------------------------------------------------------
// export let fixer;
export let fader;
export let foldOut;
export let animator;
export let smoothScrollInactive;
// export let aim;
// export let switcher;


// local variables ------------------------------------------------------------
let tickerMargin = 0;

// once function --------------------------------------------------------------
export const initOnce = () => {
  // console.log('once');

  setTimeout(() => {
    document.body.classList.remove('body--bottom-buttons-hidden');
  }, 1200); 

  // delay so fader classes are already given in page js on page load
  // can't be requestAnimationFrame because if you open in a new tab, there is no new frame
  setTimeout(() => {
    // add Fader
    fader = new Fader({
      fadeOnInit: false,
      mobileMq: '(orientation: portrait)',
      fadeDur: 150,
      // preFadeResizeDur: 200,
      // afterLoadFunction: Resize.saveOffsets, // comment so it doesn't call Static.drawStatic
    });

    // switcher = new Switcher({
    //   // duration: 400, // set to --switcher-duration
    //   afterFadeOutCallback: fader.setFaders,
    //   afterResizeCallback: Resize.setResize,
    // });
  }, 20); // less than page js fader delay

  // delay loading of other drawings
  setTimeout(() => {
    const drawingImgEls = document.querySelectorAll(`.page:not(.page--${$pageType}) .drawing__img`);
    drawingImgEls.forEach(drawingImgEl => {
      drawingImgEl.classList.add('fader', 'fader--loader', 'fader--lazy', 'fader--below-fold', 'fader--no-stagger');
    });

    fader.setFaders();
  }, Vars.transitionSlow);

  // add FoldOut
  foldOut = new FoldOut({
    buttonClass: 'info__button',
    holderClass: 'info',
    startCallback: observerBlocker,
    duringCallback: Scroll.setScroll,
    callback: observerUnblocker,
    // closeOthers: false,
    // transitionDuration: 600; // also change _fold-out.scss
    closeAllWithSameHolderClass: true,
  });

  foldOut = new FoldOut({
    buttonClass: 'filters__button--parent',
    holderClass: 'filters',
    startCallback: observerBlocker,
    duringCallback: Scroll.setScroll,
    callback: observerUnblocker,
    // closeOthers: false,
    // transitionDuration: 600; // also change _fold-out.scss
    closeAllWithSameHolderClass: true,
  });

  newsletterFoldout = new FoldOut({
    buttonClass: 'form__foldout-btn',
    holderClass: 'form',
    startCallback: observerBlocker,
    duringCallback: Scroll.setScroll,
    callback: observerUnblocker,
    // closeOthers: false,
    // transitionDuration: 600; // also change _fold-out.scss
    closeAllWithSameHolderClass: true,
  });


  // add AnimateIt
  animator = new AnimateIt({
    frameFunction: frameHandler,
  });

  // slow scroll and mouse follower
  if (typeof animator !== 'undefined') {
    // not on firefox if iframes are present
    // if (!Vars.blTouch && !Vars.blFirefox) {
    if (!Vars.blTouch) {
      const initSmoothScroll = () => {
        animator.smoothScroll({
          speed: 0.15,
          bounce: 0.75,
        });
      };

      if (typeof historyCheckWoocommerce === 'function') {
        if (!historyCheckWoocommerce(window.location.href)) initSmoothScroll();
      } else {
        initSmoothScroll();
      }
    }

    // if (document.querySelector('.mousy') && !Vars.blTouch) {
    //   animator.followMouse({
    //     selector: '.mousy',
    //     rotate: true,
    //     scrollSmear: true,
    //   });

    //   aim = document.querySelector('.animate-it-mouse');
    // }


    if (!Vars.blTouch) {
      const pages = ['home', 'program', 'camping', 'tickets', 'info', 'other'];
      pages.forEach(page => {
        const selector = '.page--' + page + ' .drawing--bottom';
        if (document.querySelector(selector)) {
          animator.wiggle({
            selector: selector,
            mousePush: true,
            slowScroll: false,
            scrollPush: true,
            speed: 0.1,
            bounce: 0.05,
            mousePushRate: 0.25,
            scrollPushRate: 1,
            wiggle: false,
          });
        }
      });
    }
  }

  smoothScrollInactive = typeof animator === 'undefined' || typeof animator.scroller !== 'object';

  // add FixBody
  // fixer = new FixBody({
  //   // elScrolling: '.main', // first scrolling element
  //   elFixedFull: smoothScrollInactive ? '.popover' : '',
  //   blUnfixWhenMqNotMatched: false,
  //   blResizeBody: smoothScrollInactive,
  // });

  // output name for devvers ----------------------------------
  console.log('%cSite by', 'color: #999; font-size: 16px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
  console.log('%cLittle Fragments', 'color: #999; font-size: 24px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
};

// functions -------------------------------------------------------------------

// so observers don't call resize while animating, which slows down the animation
export const observerBlocker = () => {
  // console.log('observerBlocker');
  Resize.setBlockResizeObserver(true); 
  if (typeof fader !== 'undefined' && fader) fader.blockResizeObserver = true;
  if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = true;
};

export const observerUnblocker = () => {
  // console.log('observerUnblocker');
  Resize.setBlockResizeObserver(false);
  Resize.setResize(true);
  if (typeof fader !== 'undefined' && fader) fader.blockResizeObserver = false;
  if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = false;
}

const frameHandler = () => {
  // console.log('frameHandler');

  // browser color
  const background = getComputedStyle(document.body).getPropertyValue('background-color');
  document.querySelector('meta[name="theme-color"]').setAttribute('content', background);

  // ticker
  const ticker = document.querySelector('.ticker');
  if (ticker) {
    if (!Listeners.tickerPaused) {
      tickerMargin -= Resize.tickerMovement;
      const tickerRepeater = document.querySelectorAll('.ticker__repeater');
      if(!tickerRepeater) return;

      if (Vars.blTouch) {
        tickerRepeater[0].style.marginLeft = tickerMargin + 'px';
      } else {
        tickerRepeater.forEach(repeater => {
          repeater.style.transform = 'translateX(' + tickerMargin + 'px)';
        });
      }

      if (tickerMargin < -Resize.tickerWidth * 2) tickerMargin = -Resize.tickerWidth;
    }
  }
};
